// React & Hooks
import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

// Routing
import { withRouter, Link } from "react-router-dom";

// Redux
import { connect } from "react-redux";

// Ant Design
import { Spin } from "antd";

// Actions
import GRNActions from "@Actions/grnActions";
import PaymentOutgoingActions from "@Actions/paymentOutgoingActions";
import PayoutActions from "@Actions/payoutActions";
import InvoiceActions from "@Actions/invoiceActions";
import AttachmentActions from "@Actions/attachmentActions";

// APIs / Helpers
import Helpers from "@Apis/helpers";
import { HideAdhocApprovals, getColumns, getColumnState } from "./helper";

// Local Components
import ViewOutgoingPaymentHeader from "./ViewOutgoingPaymentHeader";
import ViewOutgoingPaymentDetails from "./ViewOutgoingPaymentDetails";
import ViewOutgoingPaymentTables from "./ViewOutgoingPaymentTables";
import ViewOutgoingPaymentFooter from "./ViewOutgoingPaymentFooter";
import ViewDocRightSection from "../../../Common/ViewDocRightSection";

// Styles
import "./style.scss";

function ViewOutgoingPayment({
  selectedPaymentOutgoing,
  selectedAttachment,
  user,
  getPaymentOutgoingById,
  selectedPaymentId,
  getAttachmentById,
  paymentType,
  selectedPayment,
  unLinkPayment,
  callback,
  screen,
  unlinkIncomingPayment,
  updateAttachment,
  updatePaymentOutgoingWorkflowLoading,
  updatePaymentOutgoingWorkflow,
  getPaymentOutgoingByIdLoading,
  updatePaymentsOutgoingStatusLoading,
  updatePaymentsOutgoingStatus,
  unLinkPaymentLoading,
  isQuickView,
  selectPaymentTenant,
  MONEY,
  unlinkPOAdvancePayment,
  unlinkPOAdvancePaymentLoading,
  updateAttachmentLoading,
  getAttachmentByIdLoading,
}) {
  const [isGetAttachment, setIsGetAttachment] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [isUserReadyForPrefillData, setIsUserReadyForPrefillData] =
    useState(false);
  const [currentUpdate, setCurrentUpdate] = useState("");
  const [currentStatusAction, setCurrentStatusAction] = useState("");

  const columnState = useMemo(
    () =>
      getColumnState({
        selectPaymentTenant,
        MONEY,
        unLinkPayment,
        getPaymentOutgoingById,
        user,
        selectedPaymentId,
        callback,
        paymentType,
        screen,
        unlinkIncomingPayment,
        selectedPaymentOutgoing,
      }),
    []
  );

  const columns = useMemo(() => columnState.columns, []);
  const apInvoiceColumns = useMemo(() => columnState.apInvoiceColumns, []);
  const poColumns = useMemo(() => columnState.poColumns, []);
  const cnColumns = useMemo(() => columnState.cnColumns, []);
  const dnColumns = useMemo(() => columnState.dnColumns, []);

  useEffect(() => {
    if (selectedPaymentOutgoing && !isUserReadyForPrefillData) {
      setFileList(selectedPaymentOutgoing?.attachments || []);
      setIsUserReadyForPrefillData(true);
    }
  }, [selectedPaymentOutgoing, isUserReadyForPrefillData]);

  useEffect(() => {
    if (
      selectedAttachment &&
      isGetAttachment &&
      !getAttachmentByIdLoading &&
      !updateAttachmentLoading
    ) {
      setFileList(selectedAttachment);
      setIsGetAttachment(false);
    }
  }, [selectedAttachment, isGetAttachment]);

  useEffect(() => {
    getPaymentOutgoingById(
      Helpers.getTenantEntityPermission(
        user?.user_tenants,
        Helpers.permissionEntities.VENDOR_PAYOUT,
        Helpers.permissionTypes.READ
      ).join(","),
      selectedPaymentId,
      () => {},
      paymentType
    );
    getAttachmentById(selectedPaymentId, "payment_outgoing", () => {
      setIsGetAttachment(true);
      setFileList(selectedAttachment);
    });
  }, []);

  /**
   *
   * @return {JSX.Element}
   */
  let tableTitle = "";

  if (screen) {
    // Determine title based on presence of linked_invoices
    tableTitle = selectedPaymentOutgoing?.linked_invoices
      ? `LINKED INVOICES (${
          selectedPaymentOutgoing?.linked_invoices?.length || "0"
        })`
      : `LINKED DEBIT NOTES (${
          selectedPaymentOutgoing?.linked_debit_notes?.length || "0"
        })`;
  } else {
    if (selectedPaymentOutgoing?.linked_ap_invoices?.length) {
      tableTitle = `LINKED AP INVOICES (${selectedPaymentOutgoing?.linked_ap_invoices?.length})`;
    } else if (selectedPaymentOutgoing?.linked_credit_notes?.length) {
      tableTitle = `LINKED CREDIT NOTES (${selectedPaymentOutgoing?.linked_credit_notes?.length})`;
    } else {
      tableTitle = `LINKED GOODS RECEIVING NOTES (${
        selectedPaymentOutgoing?.linked_grns?.length || "0"
      })`;
    }
    `LINKED CREDIT NOTES (${
      selectedPaymentOutgoing?.linked_credit_notes?.length || "0"
    })`;
  }

  const tableColumns = selectPaymentTenant
    ? columns
    : getColumns({
        tableColumns: columns,
        user,
        selectedPaymentOutgoing,
        unLinkPayment,
        getPaymentOutgoingById,
        selectedPaymentId,
        callback,
        paymentType,
        screen,
        unlinkIncomingPayment,
      });

  let dataSource = [];
  if (screen) {
    // Determine the data source
    dataSource =
      selectedPaymentOutgoing?.linked_debit_notes ||
      selectedPaymentOutgoing?.linked_invoices ||
      [];
  } else {
    // Determine the data source
    dataSource =
      selectedPaymentOutgoing?.linked_credit_notes ||
      selectedPaymentOutgoing?.linked_grns ||
      selectedPaymentOutgoing?.linked_ap_invoices ||
      [];
  }

  return (
    <Fragment>
      {getPaymentOutgoingByIdLoading ? (
        <div className="view-payment__loader">
          <Spin />
        </div>
      ) : (
        selectedPaymentOutgoing?.payment_id && (
          <div className="view-document__wrapper">
            <div className="ant-row">
              <div className="ant-col-md-16 ant-col-xs-24">
                <div className="view-left__wrapper">
                  <ViewOutgoingPaymentHeader
                    selectedPaymentOutgoing={selectedPaymentOutgoing}
                    user={user}
                    isQuickView={isQuickView}
                    paymentType={paymentType}
                    callback={callback}
                    updatePaymentsOutgoingStatus={updatePaymentsOutgoingStatus}
                    updatePaymentsOutgoingStatusLoading={
                      updatePaymentsOutgoingStatusLoading
                    }
                    currentUpdate={currentUpdate}
                    setCurrentUpdate={setCurrentUpdate}
                  />
                  <ViewOutgoingPaymentDetails
                    selectedPaymentOutgoing={selectedPaymentOutgoing}
                    MONEY={MONEY}
                  />
                  <br />
                  <ViewOutgoingPaymentTables
                    selectedPaymentOutgoing={selectedPaymentOutgoing}
                    selectPaymentTenant={selectPaymentTenant}
                    poColumns={poColumns}
                    dnColumns={dnColumns}
                    tableColumns={tableColumns}
                    cnColumns={cnColumns}
                    apInvoiceColumns={apInvoiceColumns}
                    screen={screen}
                    tableTitle={tableTitle}
                    unLinkPaymentLoading={unLinkPaymentLoading}
                    unlinkPOAdvancePayment={unlinkPOAdvancePayment}
                    getPaymentOutgoingById={getPaymentOutgoingById}
                    selectedPaymentId={selectedPaymentId}
                    user={user}
                    unlinkPOAdvancePaymentLoading={
                      unlinkPOAdvancePaymentLoading
                    }
                    dataSource={dataSource}
                  />
                  <ViewOutgoingPaymentFooter
                    selectedPaymentOutgoing={selectedPaymentOutgoing}
                    MONEY={MONEY}
                    fileList={fileList}
                    getAttachmentByIdLoading={getAttachmentByIdLoading}
                    updateAttachmentLoading={updateAttachmentLoading}
                    updateAttachment={updateAttachment}
                    getAttachmentById={getAttachmentById}
                    setIsGetAttachment={setIsGetAttachment}
                    setFileList={setFileList}
                  />
                </div>
              </div>
              <ViewDocRightSection
                MONEY={MONEY}
                user={user}
                isQuickView={isQuickView}
                entityType="VENDOR_PAYOUT"
                entityId={selectedPaymentOutgoing?.payment_id}
                workflowTimelineProps={{
                  isEnabled: selectedPaymentOutgoing,
                  workflowSteps: selectedPaymentOutgoing?.workflow_steps || {},
                  workflowStepId: selectedPaymentOutgoing?.workflow_step_id,
                  loading: updatePaymentOutgoingWorkflowLoading,
                  updateStep: updatePaymentOutgoingWorkflow,
                  hideCase: HideAdhocApprovals(selectedPaymentOutgoing),
                  callback: () => {
                    if (callback) callback();
                    getPaymentOutgoingById(
                      Helpers.getTenantEntityPermission(
                        user?.user_tenants,
                        Helpers.permissionEntities.VENDOR_PAYOUT,
                        Helpers.permissionTypes.READ
                      ).join(","),
                      selectedPaymentId
                    );
                    setCurrentStatusAction("");
                  },
                }}
                activityLogProps={{
                  isEnabled: selectedPaymentOutgoing,
                  entityName: "Vendor Payout",
                  entityType: "vendor_payout",
                }}
              />
            </div>
          </div>
        )
      )}
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers,
  PaymentOutgoingReducers,
  PayoutReducers,
  AttachmentReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updatePaymentOutgoingWorkflowLoading:
    PaymentOutgoingReducers.updatePaymentOutgoingWorkflowLoading,
  selectedPaymentOutgoing: PaymentOutgoingReducers.selectedPaymentOutgoing,
  getPaymentOutgoingByIdLoading:
    PaymentOutgoingReducers.getPaymentOutgoingByIdLoading,
  createPaymentSessionLoading: PayoutReducers.createPaymentSessionLoading,
  deletePaymentOutgoingLoading:
    PaymentOutgoingReducers.deletePaymentOutgoingLoading,
  updatePaymentsOutgoingStatusLoading:
    PaymentOutgoingReducers.updatePaymentsOutgoingStatusLoading,
  unLinkPaymentLoading: PaymentOutgoingReducers.unLinkPaymentLoading,
  unlinkPOAdvancePaymentLoading:
    PaymentOutgoingReducers.unlinkPOAdvancePaymentLoading,
  selectedAttachment: AttachmentReducers.selectedAttachment,
  updateAttachmentLoading: AttachmentReducers.updateAttachmentLoading,
  getAttachmentByIdLoading: AttachmentReducers.getAttachmentByIdLoading,
});

const mapDispatchToProps = (dispatch) => ({
  addGRN: (payload, action) => dispatch(GRNActions.createGRN(payload, action)),
  updateGRNStatus: (payload, action) =>
    dispatch(GRNActions.updateGRNStatus(payload, action)),
  createAndLinkPayment: (payload, callback) =>
    dispatch(PaymentOutgoingActions.createAndLinkPayment(payload, callback)),
  updatePaymentOutgoingWorkflow: (payload, callback) =>
    dispatch(
      PaymentOutgoingActions.updatePaymentOutgoingWorkflow(payload, callback)
    ),
  getPaymentOutgoingById: (tenantId, paymentId, callback, paymentType) =>
    dispatch(
      PaymentOutgoingActions.getPaymentOutgoingById(
        tenantId,
        paymentId,
        callback,
        paymentType
      )
    ),
  createPaymentSession: (payload, callback) =>
    dispatch(PayoutActions.createPaymentSession(payload, callback)),
  createConnectSession: (payload, callback) =>
    dispatch(PayoutActions.createConnectSession(payload, callback)),
  getGRNById: (tenantId, grnId) =>
    dispatch(GRNActions.getGRNById(tenantId, grnId)),
  updatePaymentsOutgoingStatus: (payload, action) =>
    dispatch(
      PaymentOutgoingActions.updatePaymentsOutgoingStatus(payload, action)
    ),
  deletePaymentOutgoing: (paymentId, callback) =>
    dispatch(PaymentOutgoingActions.deletePaymentOutgoing(paymentId, callback)),
  unLinkPayment: (grnPaymentId, callback) =>
    dispatch(PaymentOutgoingActions.unLinkPayment(grnPaymentId, callback)),
  unlinkPOAdvancePayment: (payload, callback) =>
    dispatch(PaymentOutgoingActions.unlinkPOAdvancePayment(payload, callback)),
  getAttachmentById: (entityId, entityName, callback) =>
    dispatch(
      AttachmentActions.getAttachmentById(entityId, entityName, callback)
    ),
  updateAttachment: (payload, callback) =>
    dispatch(AttachmentActions.updateAttachment(payload, callback)),
  unlinkIncomingPayment: (invoicePaymentId, callback) =>
    dispatch(InvoiceActions.unlinkIncomingPayment(invoicePaymentId, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ViewOutgoingPayment));
